export default {
    name: 'QrCodeView',
    created() {
        const userAgent = navigator.userAgent;

        if (userAgent.includes('Android')) {
			window.location.href = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.lmdcmobile&ddl=1&pcampaignid=web_ddl_1';
        } else {
			window.location.href = 'https://apps.apple.com/us/app/id1523977343';
        }
    }
}